var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "15px",
    viewBox: "0 0 10 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Giving-History",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Giving-History---Print-Receipt",
    transform: "translate(-125.000000, -158.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.547991,166.116071 L127.922991,172.741071 C127.809895,172.854167 127.675968,172.910714 127.521205,172.910714 C127.366443,172.910714 127.232515,172.854167 127.11942,172.741071 L125.637277,171.258929 C125.524181,171.145833 125.467634,171.011906 125.467634,170.857143 C125.467634,170.70238 125.524181,170.568453 125.637277,170.455357 L130.378348,165.714286 L125.637277,160.973214 C125.524181,160.860118 125.467634,160.726191 125.467634,160.571429 C125.467634,160.416666 125.524181,160.282739 125.637277,160.169643 L127.11942,158.6875 C127.232515,158.574404 127.366443,158.517857 127.521205,158.517857 C127.675968,158.517857 127.809895,158.574404 127.922991,158.6875 L134.547991,165.3125 C134.661087,165.425596 134.717634,165.559523 134.717634,165.714286 C134.717634,165.869048 134.661087,166.002976 134.547991,166.116071 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.d6c0cc6eef1fd45035a8b055f3f71020.svg";
export { ForwardRef as ReactComponent };